import React from "react";
import ReactDom from "react-dom";
import RecentlyViewedListMobile from "./RecentlyViewedListMobile.jsx";

export function initRecentlyViewedMobile() {
  const div = document.querySelector(".global-header__mobile .recently-viewed");
  if (div) {
    ReactDom.render(<RecentlyViewedListMobile />, div);
  }
}
